bq.preValidation = function (element, options) {
  this.options  = options;
  this.$element = $(element);
};

bq.preValidation.DEFAULTS = {
  validations: {
    'only-numbers': [
      {
        event: 'keypress',
        callback: function(e) { return e.charCode >= 48 && e.charCode <= 57 }
      },
      {
        event: 'paste',
        callback: function(e) {
          e.stopPropagation();
          e.preventDefault();

          var pastedData = (e.originalEvent || e).clipboardData.getData('text/plain');

          return e.target.value = pastedData.replace(/[^0-9]/g, '');
        }
      }
    ],
    'float-numbers': [
      {
        event: 'keypress',
        callback: function(e) {
          var data;
          var lastPartOfData = e.target.selectionStart === e.target.selectionEnd ? e.target.selectionStart : e.target.selectionEnd;
          data = e.target.value.slice(0, e.target.selectionStart) + e.key + e.target.value.slice(lastPartOfData);

          var decimalPlaces = e.target.dataset.validateFloatNumber;
          var pattern, regex;
          if (typeof decimalPlaces === 'undefined' || isNaN(parseInt(decimalPlaces))) {
            pattern = '^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$';
          } else {
            pattern = '^[+-]?([0-9]+([.][0-9]{0,' + decimalPlaces + '})?|[.][0-9]{0,' + decimalPlaces + '})$';
          }

          regex = new RegExp(pattern);
          return regex.test(data);
        }
      },
      {
        event: 'paste',
        callback: function(e) {
          e.stopPropagation();
          e.preventDefault();

          var pastedData = (e.originalEvent || e).clipboardData.getData('text/plain');

          return e.target.value = pastedData.replace(/[^0-9.]/g, '');
        }
      }
    ]
  }
};

bq.preValidation.prototype = {
  init: function () {
    var validations = this.options.validations[this.$element.data('preValidation')];
    var $element = this.$element;

    if (!validations) return;

    validations.forEach(function (validation) {
      $element.on(validation.event, validation.callback);
    });
  }
};

var preValidationold = $.fn.preValidation;

$.fn.preValidation = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.preValidation');
    var options = $.extend({}, bq.preValidation.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) {
      $this.data('bq.preValidation', (data = new bq.preValidation(this, options)));
    }
    data.init();
  });
};

$.fn.preValidation.Constructor = bq.preValidation;

$.fn.preValidation.noConflict = function () {
  $.fn.preValidation = preValidationold;
  return this;
};

bq.preValidationInit = function () {
  $('[data-pre-validation]').each(function () {
    var el = $(this);
    if (el.data('bq.preValidation')) {
      return;
    }
    el.preValidation(el.data());
  });
};

bq.init.push(bq.preValidationInit);